export default {
	events: {
		'ddc.page.view': [
			{
				payload: {
					cli_promo_id: '[[mapping.pagealias.promo]] >> 3',
					breadcrumb_1:
						'[[mapping.pagealias.pageType]] >> [[pageAlias]]',
					dtm_cid: '3241',
					dtm_cmagic: 'a64bd5',
					dtm_fid: '106',
					dtm_user_id: '[[DDC.dataLayer.user.sessionId]]',
					dealer_name: '[[DDC.dataLayer.dealership.dealershipName]]',
					dealer_id: '[[dealerCode.volvo]]',
					dtmc_ref: '[[document.referrer]]',
					dtmc_loc: '[[document.location.href]]',
					dtmc_fpc_domain:
						'dtm.[[DDC.dataLayer.site.siteInfo.domain]]',
					dtm_user_token: '[[fn.getUserToken()]] >> {{REMOVEKEY}}',
					fpc_status: '[[fn.getFpcStatus]] >> {{REMOVEKEY}}',
					shared: [
						{
							logic: {
								'DDC.dataLayer.page.pageInfo.isVdp': true
							},
							payload: {
								vehicle_make: '[[make]] >> {{REMOVEKEY}}',
								vehicle_model: '[[model]] >> {{REMOVEKEY}}',
								vehicle_model_year: '[[year]] >> {{REMOVEKEY}}',
								vehicle_body_style:
									'[[bodyStyle]] >> {{REMOVEKEY}}',
								vehicle_trim: '[[trim]] >> {{REMOVEKEY}}',
								vehicle_color:
									'[[exteriorColor]] >> {{REMOVEKEY}}',
								vehicle_condition:
									'[[inventoryType]] >> {{REMOVEKEY}}',
								vehicle_price:
									'[[internetPrice]] >> {{REMOVEKEY}}',
								vehicle_options:
									'[[fn.getPackageNames()]] >> {{REMOVEKEY}}'
							}
						}
					]
				}
			}
		]
	}
};
